import classNames from 'classnames'
import { MyDialog } from 'components/MyDialog'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { AccountHomeLink } from '../AccountHomeLink/AccountHomeLink'

import classes from './AllOptionsModal.module.scss'
import { usePersonalizedAllOptions } from './usePersonalizedAllOptions'

type AllOptionsModalProps = {
  eMsnEnrolled?: boolean
}
export const AllOptionsModal = ({
  eMsnEnrolled = false
}: AllOptionsModalProps) => {
  const { t } = useTranslation('accountHome', { keyPrefix: 'allOptions' })
  const history = useHistory()
  const handleClose = () => {
    history.replace('/home')
  }

  const items = usePersonalizedAllOptions({ eMsnEnrolled })
  const sections: Array<keyof typeof items> = [
    'providers',
    'claims',
    'plans',
    'premiums',
    'settings'
  ]

  return (
    <MyDialog
      className={classes.dialog}
      heading={t('heading')}
      headingClassName="ds-text-heading--2xl ds-u-margin-bottom--5"
      containerId="medicare-my-add-edit-email"
      closeButtonAriaLabel={t('Close')}
      onClose={handleClose}
      width="full"
    >
      <div className="my-u-position--relative">
        <div className={classes.bg}></div>
        <div className={classNames('ds-u-padding-top--5', classes.content)}>
          {sections.map((section, idx) => (
            <section
              key={section}
              className={idx > 0 ? 'ds-u-margin-top--7' : ''}
            >
              <h3 className="ds-text-heading--xl">
                {t(`sectionHeadings.${section}`)}
              </h3>
              <div className={classes.gridContainer}>
                {items[section].map((item) => (
                  <div className={classes.item} key={item}>
                    <AccountHomeLink item={item} isInModal />
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </MyDialog>
  )
}
